/**
 * Assets Configuration
 * Centralized paths for images and static assets
 */

export const IMAGES = {
    // Hero/Banner images
    HERO_BACKGROUND: '/Images/C21_homebackground_03032022.jpeg',

    // Logo images
    LOGO_TRANSPARENT: '/Images/logo-transparent.gif',

    // Placeholder images
    PROPERTY_PLACEHOLDER: '/Images/logo-transparent.gif',

    // Partner logos
    FAIR_HOUSING: '/Images/fair-housing-logo.png',
    REALTOR: '/Images/realtor-logo.png',
} as const;

export const ICONS = {
    FAVICON: '/favicon.svg',
    APPLE_TOUCH_ICON: '/apple-touch-icon.png',
    APP_ICON_192: '/icons/icon-192.png',
    APP_ICON_512: '/icons/icon-512.png',
    APP_ICON_MASKABLE_512: '/icons/maskable-512.png',
    OG_IMAGE: '/og-image.png',
} as const;

export default IMAGES;
